import Cookies from 'js-cookie';
import { post } from './ApiService';
import { persistUserIdentity, clearStoredIdentity } from "./sessionIdentity";
import { GUEST_TOKEN, TOKEN_COOKIE, TOKEN_EXPIRES_DAYS } from "./constants";

const cookieOptions = (days = TOKEN_EXPIRES_DAYS) => ({
  expires: days,
  path: '/',
  sameSite: 'Strict',
  secure: window.location.protocol === 'https:',
});

export const guest = async () => {
  clearStoredIdentity();
  Cookies.set(TOKEN_COOKIE, GUEST_TOKEN, cookieOptions());
  return true;
};

export const login = async (email, password, action) => {
  const data = await post('/auth', { email, password, action });

  if (data.user) {
    Cookies.set(TOKEN_COOKIE, data.user.token, cookieOptions());
    persistUserIdentity(data.user);
  }

  return data;
};

export const register = async (name, email, password, action) => {
  const data = await post('/auth/register', { name, email, password, action });

  if (data.user) {
    Cookies.set(TOKEN_COOKIE, data.user.token, cookieOptions());
    persistUserIdentity(data.user);
  }

  return data;
};

export const requestPasswordReset = async (email) => {
  const resetUrl =
    typeof window !== "undefined"
      ? `${window.location.origin}/reset-password`
      : "/reset-password";
  const data = await post('/auth', {
    email,
    action: 'forgot_password',
    reset_url: resetUrl,
    redirect_url: resetUrl,
  });
  return data;
};

export const resetPassword = async (token, password) => {
  const data = await post('/auth', {
    token,
    password,
    action: 'reset_password',
  });
  return data;
};

export const logout = () => {
  clearStoredIdentity();
  Cookies.remove('token', { path: '/' });
};
